import { faLock, faLockOpen, faUnlock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { FormGroup, Input } from 'reactstrap'
import { assignUserToCourse } from 'store/AllCourses/actions'
import AxiosInstance from 'utils/AxiosInstance'
import { useHistory } from 'react-router-dom'

function CourseModalCode({ courseId, enrollmentType }) {
  const history = useHistory()

  const isAuthed = useSelector((state) => state.auth.isAuthenticated)
  const dispatch = useDispatch()

  const [accessCode, setAccessCode] = useState('')
  const [notFoundText, setNotFoundText] = useState('')

  const [loading, setLoading] = useState(false)

  const fetchCourseByAccessid = () => {
    setLoading(true)
    AxiosInstance.get(
      `/courses/access-code?accessCode=${accessCode}&courseId=${courseId}`
    ).then(async (data) => {
      await new Promise((resolve) => setTimeout(resolve, 1000))
      setLoading(false)
      if (data.course_id) {
        setNotFoundText('')

        if (isAuthed) {
          dispatch(assignUserToCourse(courseId, enrollmentType === 1))
          history.push(`/course/${courseId}`)
        } else {
          localStorage.setItem('public_catalog_course_id', courseId)
          history.push('/auth/login')
        }
      } else {
        if (data.status === 404 || data.status === 410) {
          setNotFoundText(data.message)
        } else {
          setNotFoundText(
            'No course found with this access code! Please contact academy administrator.'
          )
        }
      }
    })
  }

  return (
    <div className='mt-3'>
      <p className='text-center'>
        Please enter the access code you received from your instructor
      </p>
      <FormGroup className='ml-0 w-75 mx-auto my-3'>
        <Input
          id='exampleFormControlInput1'
          name='first_name'
          type='text'
          style={{ height: '38px' }}
          value={accessCode}
          onChange={(e) => setAccessCode(e.target.value)}
        />
        <button
          onClick={() => fetchCourseByAccessid()}
          className='btn btn-info'
        >
          {!loading ? (
            <>
              Join Course <FontAwesomeIcon className='ml-1' icon={faLock} />
            </>
          ) : (
            <>
              Joining Course ...{' '}
              <FontAwesomeIcon className='ml-1' icon={faLockOpen} />
            </>
          )}
        </button>
      </FormGroup>
      {notFoundText ? (
        <p className='text-center text-danger'>{notFoundText}</p>
      ) : null}
    </div>
  )
}

export default CourseModalCode
